module.exports = { "default": require("core-js/library/fn/json/stringify"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /Users/gebb/Desktop/live/~/babel-runtime/core-js/json/stringify.js
// module id = 77
// module chunks = 0